import { DraftConfiguration, View } from '@/types';

export const getIsConfigurationOnView = (configuration: DraftConfiguration, view: View) =>
  view.viewMaps.some((vm) => vm.printArea.id === configuration.printArea.id);
